import { createSlice } from '@reduxjs/toolkit';
import { getImpersonateDetailAction } from './impersonateDetailAction';

export const impersonateDetailSlice = createSlice({
  name: 'impersonateDetail',
  initialState: {
    loading: false,
    data: {},
    message: '',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getImpersonateDetailAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getImpersonateDetailAction.fulfilled, (state, { payload }) => {      
      state.loading = false;
      state.data = payload.data;
      state.message = payload.message;
      state.error = null;
    });
    builder.addCase(getImpersonateDetailAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || 'An error occurred';
    });
  },
});
